import { Actions, Effect, ofType } from '@ngrx/effects';
import { Injectable } from '@angular/core';
import { SupplierStateService } from 'app/profile/services/supplierstate.service';
import { ProfileService } from 'app/profile/services/profile.service';
import { SelectCurrentUser, SelectSupplierProfile, SelectSupplierContactList, SelectSupplierEntityList, SelectSupplierDocumentList, SelectSupplierWarehouseAddressList, SelectSupplierPickupWarehouseAddressList, getSupplierExternalPartnerList, SelectValidationTask, SelectSupplierContracts, SelectSupplierLocations, SelectSupplierBankList, SelectEmailDomainList, SelectSupplierMfgAddressList, SelectSupplierDiversity, SelectTabPermissions, SelectSupplierTaxList, SelectSupplierEhsResponse, SelectSupplierChannelList, SelectSupplierOtpRequest, SelectUserPendingTaskList,SelectPreventativeInProgress } from '../selectors/supplierstate.selector';
import {
  GET_SUPPLIER_ADDRESS_LIST_BY_CODE, GetSupplierAddressListByCodeSuccess, GetSupplierAddressListByCode,
  GET_SUPPLIER_PROFILE_CURRENT_USER, GetSupplierProfileCurrentUserSuccess, GET_TAB_PERMISSIONS, GetTabPermissionsSuccess,
  GetTabPermissions, GET_SUPPLIER_PROFILE, GetSupplierProfile, GetSupplierProfileSuccess, GetSupplierContactListByCode,
  GET_SUPPLIER_CONTACT_LIST_BY_CODE, GetSupplierContactListByCodeSuccess, GET_SUPPLIER_ENTITY_LIST_BY_CODE, GetSupplierEntityListByCode,
  GetSupplierEntityListByCodeSuccess, GET_SUPPLIER_DOCUMENTS_LIST_BY_CODE, GetSupplierDocumentsListByCode,
  GetSupplierDocumentsListByCodeSuccess, GetFieldConfiguration, GET_FIELD_CONFIG, GetFieldConfigurationSuccess,
  GET_SUPPLIER_WAREHOUSE_ADDRESS_LIST_BY_CODE, GetSupplierWarehouseAddressListByCode, GetSupplierWarehouseAddressListByCodeSuccess,
  GET_SUPPLIER_PICKUP_WAREHOUSE_ADDRESS_LIST_BY_CODE, GetSupplierPickupWarehouseAddressListByCode,
  GetSupplierPickupWarehouseAddressListByCodeSuccess, GET_SUPPLIER_EXTERNAL_PARTNER_LIST, GetSupplierExernalPartnerList,
  GetSupplierExernalPartnerListSuccess, GET_VALIDATION_TASK_BY_CODE, GetValidationTaskByCode, GetValidationTaskByCodeSuccess,
  GET_CONTRACTS_BY_CODE, GetContractsByCode, GetContractsByCodeSuccess, GET_SUPPLIER_LOCATIONS_BY_CODE, GetSupplierLocationsByCode,
  GetSupplierLocationsByCodeSuccess, GET_SUPPLIER_BANK_LIST_BY_CODE, GetSupplierBankListByCode, GetSupplierBankListByCodeSuccess,
  GetEmailDomains, GetEmailDomainsSuccess, GET_EMAIL_DOMAINS, GetSupplierProfileNavigationItems,
  GET_SUPPLIER_PROFILE_NAVIGATION_ITEMS, GetSupplierProfileNavigationItemsSuccess, GET_SUPPLIER_MFG_ADDRESS_LIST_BY_CODE, GetSupplierMfgAddressListByCode, GetSupplierMfgAddressListByCodeSuccess, GetSupplierDiversityByCode, GetSupplierDiversityByCodeSuccess, GET_SUPPLIER_DIVERSITY_BY_CODE, LINK_DELINK_SUPPLIER_ADDRESS_CONTACTS, LinkDelinkSupplierAddressContacts, LinkDelinkSupplierAddressContactsSuccess, GET_SUPPLIER_TAX_LIST_BY_CODE, GetSupplierTaxListByCode, GetSupplierTaxListByCodeSuccess, GET_SUPPLIER_EHS_RESPONSE_BY_CODE, GetSupplierEhsResponseByCode, GetSupplierEhsResponseByCodeSuccess, GET_SUPPLIER_CHANNEL_LIST_BY_CODE, GetSupplierChannelListByCodeSuccess, GetSupplierChannelListByCode, GetSupplierOtpRequestByUser, GET_SUPPLIER_OTP_REQUEST_BY_USER, GetSupplierOtpRequestByUserSucess, GetSupplierProfileCurrentUser, GET_SUPPLIER_PENDING_TASKS_CODE, GetSupplierPendingTasksByCode, GetSupplierPendingTasksByCodeSuccess,
  GetPreventativeInProgress,GET_PREVENTATIVE_IN_PROGRESS,GetPreventativeInProgressSuccess
} from '../actions/supplierstate.action';
import { withLatestFrom, map, filter, exhaustMap, catchError, switchMap, concat, } from 'rxjs/operators';
import { IncrementLoaderCount, PushError, DecrementLoaderCount } from 'app/shared/store/actions';
import { Store } from '@ngrx/store';
import { SupplierState } from '../state/supplierstate.state';
import { SelectSupplierAddressList, SelectNavigationList } from '../selectors/supplierstate.selector';
import { ContactsService } from 'app/profile/services/contacts.service';
import { PeopleService } from 'app/profile/services/people.service';
import { NavigationService } from 'app/profile/services/navigation.service';
import { SupplierAddressPropertyValues } from 'app/profile/models/supplier.model';
import { ExternalPartner } from 'app/profile/models/people.model';
import { SupplierDocumentService } from 'app/profile/services/supplier-document.service';
import { of } from 'rxjs';
import { GetDiversityTypesSuccess } from '../actions/masterdata.action';
import { EInvoicingService } from 'app/profile/services/einvoicing-channels.service';

@Injectable()
export class SupplierStateEffects {

  constructor(private supplierStateService: SupplierStateService,
    private profileService: ProfileService,
    private contactService: ContactsService,
    private peopleService: PeopleService,
    private documentService: SupplierDocumentService,
    private navigationService: NavigationService,
    private einvoicingService: EInvoicingService,
    private actions$: Actions,
    private store: Store<SupplierState>) { }

  @Effect()
  getCurrentUserDetails$ = this.actions$
    .pipe(
      ofType(GET_SUPPLIER_PROFILE_CURRENT_USER),
      map((action: GetSupplierProfileCurrentUser) => action),
      withLatestFrom(this.store.select(SelectCurrentUser)),
      filter(([action, state]) => action.forceReload || state == null),
      exhaustMap(() => {
        this.store.dispatch(new IncrementLoaderCount());
        return this.profileService.getUserDetails()
          .pipe(
            switchMap((data) => {
              return [
                new GetSupplierProfileCurrentUserSuccess(data),
                new DecrementLoaderCount()
              ]
            }),
            catchError((err) => {
              return [
                new PushError(err),
                new DecrementLoaderCount()
              ]
            })

          )
      })
    );
  @Effect()
  loadNavigationList$ = this.actions$
    .pipe(
      ofType(GET_SUPPLIER_PROFILE_NAVIGATION_ITEMS),
      map((action: GetSupplierProfileNavigationItems) => action),
      withLatestFrom(this.store.select(SelectNavigationList)),
      filter(([action, state]) => action.forceReload || state == null),
      exhaustMap(([action]) => {
        this.store.dispatch(new IncrementLoaderCount());
        return this.navigationService.getNavigationList()
          .pipe(
            switchMap((navigationList) => {
              return [
                new GetSupplierProfileNavigationItemsSuccess(navigationList),
                new DecrementLoaderCount()
              ]
            }),
            catchError((err) => {
              return [
                new PushError(err),
                new DecrementLoaderCount()
              ]
            })
          )
      })
    );
  @Effect()
  loadAddressList$ = this.actions$
    .pipe(
      ofType(GET_SUPPLIER_ADDRESS_LIST_BY_CODE),
      map((action: GetSupplierAddressListByCode) => action),
      withLatestFrom(this.store.select(SelectSupplierAddressList)),
      filter(([action, state]) => action.forceReload || state == null),
      exhaustMap(([action]) => {
        this.store.dispatch(new IncrementLoaderCount());
        return this.supplierStateService.getAddressListByCode(action.payload)
          .pipe(
            switchMap((addresses) => {
              return [
                new GetSupplierAddressListByCodeSuccess(addresses),
                new DecrementLoaderCount()
              ]
            }),
            catchError((err) => {
              return [
                new PushError(err),
                new DecrementLoaderCount()
              ]
            })
          )
      })
    );

  @Effect()
  loadDocumentsList$ = this.actions$
    .pipe(
      ofType(GET_SUPPLIER_DOCUMENTS_LIST_BY_CODE),
      map((action: GetSupplierDocumentsListByCode) => action),
      withLatestFrom(this.store.select(SelectSupplierDocumentList)),
      filter(([action, state]) => action.forceReload || state == null),
      exhaustMap(([action]) => {
        this.store.dispatch(new IncrementLoaderCount());
        return this.supplierStateService.getDocumentsListByCode(action.payload)
          .pipe(
            switchMap((documents) => {
              return [
                new GetSupplierDocumentsListByCodeSuccess(documents),
                new DecrementLoaderCount()
              ]
            }),
            catchError((err) => {
              return [
                new PushError(err),
                new DecrementLoaderCount()
              ]
            })
          )
      })
    );

  @Effect()
  loadTabPermissions$ = this.actions$
    .pipe(
      ofType(GET_TAB_PERMISSIONS),
      map((action: GetTabPermissions) => action),
      withLatestFrom(this.store.select(SelectTabPermissions)),
      filter(([action, state]) => action.forceReload || state == null),
      exhaustMap(([action]) => {
        this.store.dispatch(new IncrementLoaderCount());
        return this.supplierStateService.getTabPermissions(action.payload)
          .pipe(
            switchMap((data) => {
              return [
                new GetTabPermissionsSuccess(data),
                new DecrementLoaderCount()
              ]
            }),
            catchError((err) => {
              return [
                new PushError(err),
                new DecrementLoaderCount()
              ]
            })
          )
      })
    );

  @Effect()
  loadSupplierProfile$ = this.actions$
    .pipe(
      ofType(GET_SUPPLIER_PROFILE),
      map((action: GetSupplierProfile) => action),
      withLatestFrom(this.store.select(SelectSupplierProfile)),
      filter(([action, state]) => action.forceReload || state == null || (state.supplierDetails && (state.supplierDetails.supplierCode != action.payload))),
      exhaustMap(([action]) => {
        this.store.dispatch(new IncrementLoaderCount());
        return this.profileService.getBasicInfo(action.payload)
          .pipe(
            switchMap((supplierProfile) => {
              return [
                new GetSupplierProfileSuccess(supplierProfile),
                new DecrementLoaderCount()
              ]
            }),
            catchError((err) => {
              return [
                new PushError(err),
                new DecrementLoaderCount()
              ]
            })
          )
      })
    );

  @Effect()
  loadContactList$ = this.actions$
    .pipe(
      ofType(GET_SUPPLIER_CONTACT_LIST_BY_CODE),
      map((action: GetSupplierContactListByCode) => action),
      withLatestFrom(this.store.select(SelectSupplierContactList)),
      filter(([action, state]) => action.forceReload || state == null),
      exhaustMap(([action]) => {
        this.store.dispatch(new IncrementLoaderCount());
        return this.contactService.GetSupplierContactListByCode(action.payload)
          .pipe(
            switchMap((contacts) => {
              return [
                new GetSupplierContactListByCodeSuccess(contacts),
                new DecrementLoaderCount()
              ]
            }),
            catchError((err) => {
              return [
                new PushError(err),
                new DecrementLoaderCount()
              ]
            })
          )
      })
    );
  @Effect()
  loadEamilDomainList$ = this.actions$
    .pipe(
      ofType(GET_EMAIL_DOMAINS),
      map((action: GetEmailDomains) => action),
      withLatestFrom(this.store.select(SelectEmailDomainList)),
      filter(([action, state]) => action.forceReload || state == null),
      exhaustMap(([action]) => {
        this.store.dispatch(new IncrementLoaderCount());
        return this.contactService.getEmailDomainByCode(action.payload)
          .pipe(
            switchMap((domains) => [
              new GetEmailDomainsSuccess(domains),
              new DecrementLoaderCount()
            ]),
            catchError((err) => of(new PushError(err)))
          );
      })
    );

  @Effect()
  loadPendingTasks$ = this.actions$
    .pipe(
      ofType(GET_SUPPLIER_PENDING_TASKS_CODE),
      map((action: GetSupplierPendingTasksByCode) => action),
      withLatestFrom(this.store.select(SelectUserPendingTaskList)),
      filter(([action, state]) => action.forceReload || state == null),
      exhaustMap(([action]) => {
        this.store.dispatch(new IncrementLoaderCount());
        return this.contactService.getSupplierPendingTasksByCode(action.payload)
          .pipe(
            switchMap((tasks) => {
              return [
                new GetSupplierPendingTasksByCodeSuccess(tasks),
                new DecrementLoaderCount()
              ]
            }),
            catchError((err) => {
              return [
                new PushError(err),
                new DecrementLoaderCount()
              ]
            })
          )
      })
    );

  @Effect()
  loadPreventativeInProgress$ = this.actions$
  .pipe(
    ofType(GET_PREVENTATIVE_IN_PROGRESS),
    map((action: GetPreventativeInProgress) => action),
    withLatestFrom(this.store.select(SelectPreventativeInProgress)),
    filter(([action, state]) => action.forceReload || state == null),
    exhaustMap(([action]) => {
      this.store.dispatch(new IncrementLoaderCount());
      return this.profileService.getPreventativeStatus(action.payload)
        .pipe(
          switchMap((response) => [
            new GetPreventativeInProgressSuccess(response),
            new DecrementLoaderCount()
          ]),
          catchError((err) => of(new PushError(err)))
        );
    })
  );

  @Effect()
  loadEntityList$ = this.actions$
    .pipe(
      ofType(GET_SUPPLIER_ENTITY_LIST_BY_CODE),
      map((action: GetSupplierEntityListByCode) => action),
      withLatestFrom(this.store.select(SelectSupplierEntityList)),
      filter(([action, state]) => action.forceReload || state == null),
      exhaustMap(([action]) => {
        this.store.dispatch(new IncrementLoaderCount());
        return this.contactService.getEntityListByCode(action.payload)
          .pipe(
            switchMap((entities) => {
              return [
                new GetSupplierEntityListByCodeSuccess(entities),
                new DecrementLoaderCount()
              ]
            }),
            catchError((err) => {
              return [
                new PushError(err),
                new DecrementLoaderCount()
              ]
            })
          )
      })
    );

  @Effect()
  loadFieldConfigsByCountry$ = this.actions$
    .pipe(
      ofType(GET_FIELD_CONFIG),
      map((action: GetFieldConfiguration) => action.payload),
      exhaustMap((payload) => {
        return this.supplierStateService.getFieldConfig(
          payload.Section,
          payload.CountryCode,
          payload.EntityName,
          payload.SubCategory)
          .pipe(
            switchMap((data) => {
              return [
                new GetFieldConfigurationSuccess(data),
                new DecrementLoaderCount()]
            }),
            catchError((err) => {
              return [
                new PushError(err),
                new DecrementLoaderCount()
              ]
            })
          )
      })
    )


  @Effect()
  loadWarehouseAddressList$ = this.actions$
    .pipe(
      ofType(GET_SUPPLIER_WAREHOUSE_ADDRESS_LIST_BY_CODE),
      map((action: GetSupplierWarehouseAddressListByCode) => action),
      withLatestFrom(this.store.select(SelectSupplierWarehouseAddressList)),
      filter(([action, state]) => action.forceReload || state == null),
      exhaustMap(([action]) => {
        this.store.dispatch(new IncrementLoaderCount());
        return this.profileService.getWarehouses(action.payload)
          .pipe(
            switchMap((addresses) => {
              return [
                new GetSupplierWarehouseAddressListByCodeSuccess(addresses),
                new DecrementLoaderCount()
              ]
            }),
            catchError((err) => {
              return [
                new PushError(err),
                new DecrementLoaderCount()
              ]
            })
          )
      })
    );

  @Effect()
  loadPickupWarehouseAddressList$ = this.actions$
    .pipe(
      ofType(GET_SUPPLIER_PICKUP_WAREHOUSE_ADDRESS_LIST_BY_CODE),
      map((action: GetSupplierPickupWarehouseAddressListByCode) => action),
      withLatestFrom(this.store.select(SelectSupplierPickupWarehouseAddressList)),
      filter(([action, state]) => action.forceReload || state == null),
      exhaustMap(([action]) => {
        this.store.dispatch(new IncrementLoaderCount());
        return this.profileService.getPickupWarehouses(action.payload)
          .pipe(
            switchMap((addresses) => {
              return [
                new GetSupplierPickupWarehouseAddressListByCodeSuccess(addresses),
                new DecrementLoaderCount()
              ]
            }),
            catchError((err) => {
              return [
                new PushError(err),
                new DecrementLoaderCount()
              ]
            })
          )
      })
    );

  @Effect()
  loadMfgAddressList$ = this.actions$
    .pipe(
      ofType(GET_SUPPLIER_MFG_ADDRESS_LIST_BY_CODE),
      map((action: GetSupplierMfgAddressListByCode) => action),
      withLatestFrom(this.store.select(SelectSupplierMfgAddressList)),
      filter(([action, state]) => action.forceReload || state == null),
      exhaustMap(([action]) => {
        this.store.dispatch(new IncrementLoaderCount());
        return this.profileService.getManufacturingAddress(action.payload)
          .pipe(
            switchMap((addresses) => {
              return [
                new GetSupplierMfgAddressListByCodeSuccess(addresses),
                new DecrementLoaderCount()
              ]
            }),
            catchError((err) => {
              return [
                new PushError(err),
                new DecrementLoaderCount()
              ]
            })
          )
      })
    );

  @Effect()
  loadExternalPartnerList$ = this.actions$
    .pipe(
      ofType(GET_SUPPLIER_EXTERNAL_PARTNER_LIST),
      map((action: GetSupplierExernalPartnerList) => action),
      withLatestFrom(this.store.select(getSupplierExternalPartnerList)),
      filter(([action, state]) => action.forceReload || state == null),
      exhaustMap(([action]) => {
        this.store.dispatch(new IncrementLoaderCount());
        return this.peopleService.getExternalPartners(action.payload)
          .pipe(
            map(list => {
              return list.map((x: ExternalPartner) => {
                const externalAddress = new SupplierAddressPropertyValues();
                externalAddress.street1.newValue = x.address1;
                externalAddress.street2.newValue = x.address2;
                externalAddress.city.newValue = x.city;
                externalAddress.state.newValue = x.state;
                externalAddress.zipCode.newValue = x.zipCode;
                externalAddress.countryCode.newValue = x.country ? x.country.abbreviation : '';
                externalAddress.comment.newValue = 'N/A';
                externalAddress.types.newValue = ['External Partner'];
                externalAddress.locationName = x.companyName;
                return externalAddress;
              });
            }),
            switchMap((externals) => {
              return [
                new GetSupplierExernalPartnerListSuccess(externals),
                new DecrementLoaderCount()
              ]
            }),
            catchError((err) => {
              return [
                new PushError(err),
                new DecrementLoaderCount()
              ]
            })
          )
      })
    );

  @Effect()
  loadValidationTaskList$ = this.actions$
    .pipe(
      ofType(GET_VALIDATION_TASK_BY_CODE),
      map((action: GetValidationTaskByCode) => action),
      withLatestFrom(this.store.select(SelectValidationTask)),
      filter(([action, state]) => action.forceReload || state == null),
      exhaustMap(([action]) => {
        this.store.dispatch(new IncrementLoaderCount());
        return this.contactService.GetValidationTaskByCode(action.payload)
          .pipe(
            switchMap((validationTask) => {
              return [
                new GetValidationTaskByCodeSuccess(validationTask),
                new DecrementLoaderCount()
              ]
            }),
            catchError((err) => {
              return [
                new PushError(err),
                new DecrementLoaderCount()
              ]
            })
          )
      })
    );

  @Effect()
  getContracts$ = this.actions$
    .pipe(
      ofType(GET_CONTRACTS_BY_CODE),
      map((action: GetContractsByCode) => action),
      withLatestFrom(this.store.select(SelectSupplierContracts)),
      filter(([action, state]) => action.forceReload || state == null),
      exhaustMap(([action]) => {
        this.store.dispatch(new IncrementLoaderCount());
        return this.documentService.getContracts(action.payload)
          .pipe(
            switchMap((contracts) => {
              return [
                new GetContractsByCodeSuccess(contracts),
                new DecrementLoaderCount()
              ]
            }),
            catchError((err) => {
              return [
                new PushError(err),
                new DecrementLoaderCount()
              ]
            })
          )
      })
    );
  @Effect()
  getSupplierLocations$ = this.actions$
    .pipe(
      ofType(GET_SUPPLIER_LOCATIONS_BY_CODE),
      map((action: GetSupplierLocationsByCode) => action),
      withLatestFrom(this.store.select(SelectSupplierLocations)),
      filter(([action, state]) => action.forceReload || state == null),
      exhaustMap(([action]) => {
        this.store.dispatch(new IncrementLoaderCount());
        return this.profileService.getLocations(action.payload)
          .pipe(
            switchMap((locations) => {
              return [
                new GetSupplierLocationsByCodeSuccess(locations),
                new DecrementLoaderCount()
              ]
            }),
            catchError((err) => {
              return [
                new PushError(err),
                new DecrementLoaderCount()
              ]
            })
          )
      })
    );

  @Effect()
  loadBanksList$ = this.actions$
    .pipe(
      ofType(GET_SUPPLIER_BANK_LIST_BY_CODE),
      map((action: GetSupplierBankListByCode) => action),
      withLatestFrom(this.store.select(SelectSupplierBankList)),
      filter(([action, state]) => action.forceReload || state == null),
      exhaustMap(([action]) => {
        this.store.dispatch(new IncrementLoaderCount());
        return this.supplierStateService.getBankListByCode(action.payload)
          .pipe(
            switchMap((bankinfo) => {
              return [
                new GetSupplierBankListByCodeSuccess(bankinfo),
                new DecrementLoaderCount()
              ]
            }),
            catchError((err) => {
              return [
                new PushError(err),
                new DecrementLoaderCount()
              ]
            })
          )
      })
    );

  @Effect()
  loadTaxList$ = this.actions$
    .pipe(
      ofType(GET_SUPPLIER_TAX_LIST_BY_CODE),
      map((action: GetSupplierTaxListByCode) => action),
      withLatestFrom(this.store.select(SelectSupplierTaxList)),
      filter(([action, state]) => action.forceReload || state == null),
      exhaustMap(([action]) => {
        this.store.dispatch(new IncrementLoaderCount());
        return this.supplierStateService.getTaxListByCode(action.payload)
          .pipe(
            switchMap((taxinfo) => {
              return [
                new GetSupplierTaxListByCodeSuccess(taxinfo),
                new DecrementLoaderCount()
              ]
            }),
            catchError((err) => {
              return [
                new PushError(err),
                new DecrementLoaderCount()
              ]
            })
          )
      })
    );

  @Effect()
  loadSupplierDiversity$ = this.actions$
    .pipe(
      ofType(GET_SUPPLIER_DIVERSITY_BY_CODE),
      map((action: GetSupplierDiversityByCode) => action),
      withLatestFrom(this.store.select(SelectSupplierDiversity)),
      filter(([action, state]) => action.forceReload || state == null),
      exhaustMap(([action]) => {
        this.store.dispatch(new IncrementLoaderCount());
        return this.supplierStateService.getDiversityByCode(action.payload)
          .pipe(
            switchMap((bankinfo) => {
              return [
                new GetSupplierDiversityByCodeSuccess(bankinfo),
                new DecrementLoaderCount()
              ]
            }),
            catchError((err) => {
              return [
                new PushError(err),
                new DecrementLoaderCount()
              ]
            })
          )
      })
    );


  @Effect()
  postLinkDelinkEvent$ = this.actions$
    .pipe(
      ofType(LINK_DELINK_SUPPLIER_ADDRESS_CONTACTS),
      map((action: LinkDelinkSupplierAddressContacts) => action.payload),
      exhaustMap((payload) => {
        this.store.dispatch(new IncrementLoaderCount());
        return this.profileService.updateLocationContacts(payload.supplierCode, payload.contacts)
          .pipe(
            switchMap((suppliers) => {
              return [
                new LinkDelinkSupplierAddressContactsSuccess(suppliers)
              ]
            }),
            catchError((err) => {
              return [
                new PushError(err),
                new DecrementLoaderCount()
              ]
            })
          )
      })
    );

  @Effect()
  loadSupplierEhsResponse$ = this.actions$
    .pipe(
      ofType(GET_SUPPLIER_EHS_RESPONSE_BY_CODE),
      map((action: GetSupplierEhsResponseByCode) => action),
      withLatestFrom(this.store.select(SelectSupplierEhsResponse)),
      filter(([action, state]) => action.forceReload || state == null),
      exhaustMap(([action]) => {
        this.store.dispatch(new IncrementLoaderCount());
        return this.supplierStateService.getEhsResponseByCode(action.payload)
          .pipe(
            switchMap((info) => {
              return [
                new GetSupplierEhsResponseByCodeSuccess(info),
                new DecrementLoaderCount()
              ]
            }),
            catchError((err) => {
              return [
                new PushError(err),
                new DecrementLoaderCount()
              ]
            })
          )
      })
    );

  @Effect()
  loadChannelList$ = this.actions$
    .pipe(
      ofType(GET_SUPPLIER_CHANNEL_LIST_BY_CODE),
      map((action: GetSupplierChannelListByCode) => action),
      withLatestFrom(this.store.select(SelectSupplierChannelList)),
      filter(([action, state]) => action.forceReload || state == null),
      exhaustMap(([action]) => {
        this.store.dispatch(new IncrementLoaderCount());
        return this.einvoicingService.getChannelListByCode(action.payload)
          .pipe(
            switchMap((channelList) => {
              return [
                new GetSupplierChannelListByCodeSuccess(channelList),
                new DecrementLoaderCount()
              ]
            }),
            catchError((err) => {
              return [
                new PushError(err),
                new DecrementLoaderCount()
              ]
            })
          )
      })
    );

  @Effect()
  getSupplierOtpRequest$ = this.actions$
    .pipe(
      ofType(GET_SUPPLIER_OTP_REQUEST_BY_USER),
      map((action: GetSupplierOtpRequestByUser) => action),
      withLatestFrom(this.store.select(SelectSupplierOtpRequest)),
      filter(([action, state]) => action.forceReload || state == null),
      exhaustMap(([action]) => {
        this.store.dispatch(new IncrementLoaderCount());
        return this.profileService.getSupplierValidations(action.supplierCode)
          .pipe(
            switchMap((request) => {
              return [
                new GetSupplierOtpRequestByUserSucess(request),
                new DecrementLoaderCount()
              ]
            }),
            catchError((err) => {
              return [
                new PushError(err),
                new DecrementLoaderCount()
              ]
            })
          )
      })
    );
}
